import { useState } from 'react';
import { DRAWER_PAGE_SIZE } from '@constants/limits';
import { REFRESH_MS } from '@constants/timing';
import { locationPaths, useApi, type LocationPage } from '@lib/api';
import { useStreamRefresh } from '@lib/stream';

/**
 * Locations of the distribution network, a page at a time (offset, kept in component state): the direct children
 * of one location (`parentId`), or an operator's whole network (`mine`). Null = nothing to ask (no children).
 * Stock follows live changes.
 */
export function useNetworkPage(of: { parentId: number } | 'mine' | null) {
  const [page, setPage] = useState(1);
  const path = of === null ? null : locationPaths.list({ ...(of === 'mine' ? { network: 'mine' as const } : { parentId: of.parentId }), page, limit: DRAWER_PAGE_SIZE });
  const state = useApi<LocationPage>(path, { keepPrevious: true });
  useStreamRefresh(['movement', 'shipment.updated', 'cylinder.updated'], state.reload, REFRESH_MS.locationDetail);
  return { state, setPage };
}

export type NetworkPage = ReturnType<typeof useNetworkPage>;
